<template>
  <div>
    <v-layout>

        <v-flex xs6>  <v-checkbox label="Çoklu Bilet Girişi" v-model="coklubilet" hide-details=""></v-checkbox></v-flex>
    </v-layout>

    <v-text-field hide-details="" ref="ara" autofocus="" v-model="denemedeger" mask="##########"  :label="ilkbiletlabel">
    </v-text-field>
    <v-text-field v-if="coklubilet" hide-details="" ref="ara" autofocus="" v-model="sonbiletno" mask="##########"  label="Son Bilet No">
    </v-text-field>
    <havayollaricomp :etiket="'Hava Yolu Kodu'" v-model="havayolubil"></havayollaricomp>
    <v-select hide-details=""  v-model="val.GenelBilgileri.UcusTipi" :items="ucustipi" clearable
      item-text="text" item-value="value" label="Uçuş Tipi"></v-select>
    <v-checkbox label="Bu bilet acentadan alınmıştır." v-model="acentabiletimi" hide-details=""></v-checkbox>
    <div v-if="acentabiletimi">
     <havayollaricomp :etiket="'Acente Kodu'" v-model="acentabil"></havayollaricomp>
    </div>

  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  export default {
    props: ["value"],
    components: {},
    computed: {
      val: {
        get: function () {
          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      },
    },
    mounted: function () {

    },
    watch: {
      'coklubilet': function (deger) {
        if (deger==true) {
          this.ilkbiletlabel='İlk Bilet No';
          this.val.GenelBilgileri.Baglantili=true;
        } else {this.ilkbiletlabel='Bilet No';
         this.val.GenelBilgileri.ArkmanUsers =  null;
         this.sonbiletno=null;
         this.val.GenelBilgileri.Baglantili=false;
        }
      },
      'denemedeger': function (value1) {

        if(this.coklubilet==true) {
          this.sonbiletno=this.denemedeger
        }
        if (value1.length == 10) {
          this.val.GenelBilgileri.BiletNo = value1
        } else {
          this.val.GenelBilgileri.BiletNo = null
        }
      },
      'sonbiletno': function (degerson) {
        if (this.coklubilet==true && degerson.length == 10) {
          this.val.GenelBilgileri.ArkmanUsers = degerson
        } else {
          this.val.GenelBilgileri.ArkmanUsers =  null
        }
      },
      'havayolubil.havayolukodu': function (value2) {
         this.val.GenelBilgileri.HavaYoluKodu=value2
      },
       'havayolubil.formno': function (value3) {
         this.val.GenelBilgileri.Formno=value3
      },
       'acentabil.havayolukodu': function (value4) {
         this.val.GenelBilgileri.AcenteKodu=value4
         this.val.GenelBilgileri.Acente='A'
      }
    },
    beforeMount: beforeMount,
    components: {
      havayollaricomp
    },
    methods: {
      hey(title) {
        if (title == 'yeni') {
          this.kaydetbuton = true
          this.tahsilatguncellebuton = false
        }
        this.yenidialog = true;
        return new Promise((resolve, reject) => {
          this.resolve = resolve;
          this.reject = reject;
        });
      },

      formnoal: formnoal,
    },
    data() {
      return {
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
         acentabil: {
          havayolukodu: null
        },
        itemsairlinelist: [],
        secilenformno: null,
        secilenhavayolukodu: null,
        ucustipi: [{
            text: 'İç Hat',
            value: 'I'
          },
          {
            text: 'Dış Hat',
            value: 'D'
          },
          {
            text: 'BSP',
            value: 'B'
          }
        ],
        coklubilet:false,
        ilkbiletlabel:'Bilet No',
sonbiletno:null,
        acentabiletimi: false,
        yenidialog: false,
        denemedeger: null,
        dialogbaslik: '',
        resolve: null,
        kaydetbuton: false,
        tahsilatguncellebuton: false,
        k: null,
        doviztipi: [],
        reject: null,
        bankapositems: [],
        itemsbanka: [],
        statecaritahsilat: [],
        itemsevraktipi: [],
        tahsilatdialog: false,
        text1: null,
        searchcaritahsilat: '',
        taksitsayitahsilat: [],
        loading: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
      }
    },


  }

  function formnoal(y) {
    var tumliste = []
    tumliste = this.itemsairlinelist
    tumliste.forEach(element => {
      if (element.HavaYoluKodu == y) {
        this.val.GenelBilgileri.Formno = String(element.FormNo)
      }
    });
  }


  function beforeMount() {
      requestAnimationFrame(() => {
        this.$refs.ara.focus()
      })


  }
</script>